/**
 * WebView Constants
 */

export const WEBVIEW_CONSTANTS = {
  // Storage keys
  STORAGE_KEYS: {
    EXTERNAL_PROPS: 'tahta_webview_props',
    AUTH_STATE: 'tahta_webview_auth',
    LAST_SYNC: 'tahta_webview_last_sync',
  },

  // Timeouts
  TIMEOUTS: {
    INIT_CHECK: 100,        // Initial WebView check timeout
    AUTH_TIMEOUT: 30000,    // Auth operation timeout (30s)
    MESSAGE_TIMEOUT: 5000,  // Message response timeout (5s)
  },

  // Token expiry
  TOKEN_EXPIRY: {
    ACCESS_TOKEN: 86400,    // 24 hours in seconds
    FIREBASE_TOKEN: 3600,   // 1 hour in seconds (Firebase default)
  },

  // Role mappings
  ROLE_MAPPINGS: {
    student: ['Student'],
    teacher: ['Teacher'],
    admin: ['Admin', 'Teacher'],
    viewer: ['Viewer'],
  },

  // Error codes
  ERROR_CODES: {
    INVALID_PROPS: 'WEBVIEW_INVALID_PROPS',
    AUTH_FAILED: 'WEBVIEW_AUTH_FAILED',
    TOKEN_EXCHANGE_FAILED: 'WEBVIEW_TOKEN_EXCHANGE_FAILED',
    MESSAGE_TIMEOUT: 'WEBVIEW_MESSAGE_TIMEOUT',
    FIREBASE_AUTH_FAILED: 'WEBVIEW_FIREBASE_AUTH_FAILED',
  },

  // Debug settings
  DEBUG: {
    LOG_MESSAGES: true,
    LOG_AUTH: true,
    LOG_ERRORS: true,
  },
} as const;

export type WebViewErrorCode = typeof WEBVIEW_CONSTANTS.ERROR_CODES[keyof typeof WEBVIEW_CONSTANTS.ERROR_CODES];